import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

const  state =  {
    loggedInUser: {},
    getGeneralSettings:{},
    showDepartment:'',
    showPriroty:'',
    showPicture:'',
    showDueDate:'',
    showServiceTab:'',
    callTicketsViewApi: {},
    session_id: null,
    user_id: null,
    fcm_details: {
        fcm_token: "",
        fcm_server_key: ""
    }
  }
const getters =  {
  loggedInUser: state => state.loggedInUser,
  getGeneralSettings: state => state.getGeneralSettings,
  showDepartment: state =>state.showDepartment,
  showPriroty: state =>state.showPriroty,
  showPicture: state =>state.showPicture,
  showDueDate:state => state.showDueDate,
  showServiceTab:state => state.showServiceTab,
  callTicketsViewApi:state => state.callTicketsViewApi,
  fcmDetails: state => state.fcm_details,
  session_id: state => state.session_id,
  user_id: state => state.user_id,
}
const mutations = {
    setLoggedInUser(state, user) {
      state.loggedInUser = user;
    },
    setGeneralSettings(state, general){
      state.getGeneralSettings = general;
    },
    setShowDepartment(state,value){
      state.showDepartment = value
    },
    setShowPriroty(state,priroty){
      state.showPriroty = priroty
    },
    setShowPicture(state,picture){
      state.showPicture = picture
    },
    setShowDueDate(state,dateName){
      state.showDueDate = dateName
    },
    setShowServiceTab(state,service){
      state.showServiceTab = service
    },
    setCallTicketsViewApi(state,isApiCalled){
      state.callTicketsViewApi = isApiCalled
    },
    setSessionId(state, session_id) {
        state.session_id = session_id
    },
    setFCMDetails(state, fcm_details) {
        state.fcm_details = fcm_details
    },
    setUserId(state, user_id) {
      state.user_id = user_id
    }
}    
export default ({
  state,
  getters,
  mutations
})